import axiosInstance from "../../axios/index";
import {
  SET_NOTIFICATIONS,
  CONNECT,
  DISCONNECT,
} from "../types/notificationsTypes";
import { requestFailed } from "./feedbackActionCreators";
import { automaticSignOut } from "./userActionCreators";
import { alertError } from "../../utils/feedback";
import { ERROR_MESSAGE } from "../types/chatTypes";
import io from "socket.io-client";
import { getOrganizatonMetricsById } from "./organizationProfileCreators";

export const setAllNotifications = (notifcations) => ({
  type: SET_NOTIFICATIONS,
  payload: notifcations,
});

export const disconnectEvent = () => ({
  type: DISCONNECT,
});

export const connectionEvent = () => ({
  type: CONNECT,
});

export const errorMessage = (err) => {
  const language = localStorage.getItem("i18nextLng");
  let errorM;
  console.log("errorMessage : ", err);
  if (language === "en") {
    errorM =
      err?.message || (err?.message === null ? undefined : "Request failed");
  } else if (language === "fr") {
    errorM =
      err?.message_fr ||
      (err?.message_fr === null ? undefined : "Request failed");
  }
  if (typeof err == "string") errorM = err;

  if (err.error_ === "token expired") {
    return automaticSignOut();
  } else {
    alertError(errorM);
  }

  return {
    type: ERROR_MESSAGE,
    payload: "",
  };
};

export const fetchAllNotifications = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get(`/auth/admin_recent_notifications`);
      const items = res?.data?.notifications;
      if (items && items.length > 0) {
        let called = false;

        for (let item of items) {
          if (!item?.is_read && item?.existing_report && !called) {
            const orgaId = localStorage.getItem("orgaId");
            const normalizedOrgaId = orgaId ? String(orgaId).trim() : "";
            if (
              normalizedOrgaId &&
              normalizedOrgaId !== "null" &&
              normalizedOrgaId !== "undefined"
            ) {
              dispatch(getOrganizatonMetricsById(normalizedOrgaId));
            }
            called = true;
            break; // stop loop once triggered
          }
        }
      }
      dispatch(setAllNotifications(items));
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const updateNotification = (id) => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.put(
        `/auth/update_admin_notification/${id}`,
        {
          is_read: true,
        }
      );
      dispatch(fetchAllNotifications());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

let socket = io(`${process.env.REACT_APP_API_URL_NOTIFICATION}`, {
  transports: ["websocket"],
  autoConnect: false, // Prevent automatic connection on initialization
});

export const initializeSocketListeners = (token) => async (dispatch) => {
  if (socket.connected) {
    return;
  }

  socket.io.opts.query = {
    "x-access-token": token, // Send the updated token in the query params
  };

  socket.connect();
  console.log("on init", socket.io.opts.query);

  socket.on("connect", () => {
    //alert("Socket connected");
    console.log("on connect", socket.io.opts.query);
    dispatch(connectionEvent());
  });

  socket.emit("notif", {});
  socket.on("notif", (res) => {
    console.log("on notif", res);
    if (res.status === "success") {
      dispatch(fetchAllNotifications());
    } else if (res.status === "failure") {
      errorMessage(res);
    }
  });

  socket.emit("server_error", {});
  socket.on("server_error", (error) => {
    console.log("on server error", socket.io.opts.query);
    dispatch(errorMessage(error));
  });

  socket.on("disconnect", (error) => {
    //alert("disconnected socket")
    console.log("disconnected from the socket server");
    dispatch(disconnectEvent(error));
  });
};

export const socketDisconnect = async () => {
  await socket.disconnect();
  socket.io.opts.query = {};
  console.log("on diconnect function : ", socket.io.opts.query);
};
